import { z } from 'zod';
import { email, isoDate, phone } from './common.js';
import { WorkerStatus, RtwStatus } from '../types/enums.js';
export const emergencyContactSchema = z.object({
    name: z.string().min(1),
    phone,
    relationship: z.string().min(1),
});
export const createWorkerSchema = z.object({
    name: z.string().min(1, 'Name is required').max(120),
    phone,
    email: z.union([email, z.literal('')]).nullable().optional(),
    postcode: z.string().min(2).max(12),
    address: z.string().nullable().optional(),
    role: z.string().min(1),
    roles: z.array(z.string()).default([]),
    status: z.nativeEnum(WorkerStatus).default(WorkerStatus.available),
    onSiteUntil: isoDate.nullable().optional(),
    emergency: emergencyContactSchema.nullable().optional(),
    companyRef: z.string().nullable().optional(),
    payrollRef: z.string().nullable().optional(),
    agencyCode: z.string().nullable().optional(),
    photo: z.string().nullable().optional(),
    core: z.boolean().default(false),
    rating: z.number().int().min(0).max(5).default(0),
    rtwStatus: z.nativeEnum(RtwStatus).nullable().optional(),
    rtwExpiry: isoDate.nullable().optional(),
    nationality: z.string().nullable().optional(),
});
export const updateWorkerSchema = createWorkerSchema.partial();
export const workerQuerySchema = z.object({
    search: z.string().optional(),
    role: z.string().optional(),
    status: z.nativeEnum(WorkerStatus).optional(),
    agencyCode: z.string().optional(),
    rtwStatus: z.nativeEnum(RtwStatus).optional(),
    visaExpiring: z.coerce.boolean().optional(),
    core: z.coerce.boolean().optional(),
    certStatus: z.enum(['ok', 'warn', 'alert']).optional(),
});
export const addCertSchema = z.object({
    type: z.string().min(1),
    expiry: isoDate,
    docRef: z.string().nullable().optional(),
    docUrl: z.string().nullable().optional(),
});
export const updateCertSchema = addCertSchema.partial();
export const addWorkerNoteSchema = z.object({
    text: z.string().min(1),
});
//# sourceMappingURL=worker.js.map